import { lazyRouteComponent } from "@tanstack/react-router";




const Contact = lazyRouteComponent(() => import("./kontakt.view"), "Contact");

export const routeOptions = {
  component: Contact,
  head: () => ({
    meta: [
      { title: "Kontakt – Alkoholprovet" },
      { name: "description", content: "Kontakta Alkoholprovet vid frågor om tjänsten, kvitton eller tekniska problem. Vi svarar normalt inom 1–2 arbetsdagar." },
      { property: "og:title", content: "Kontakta Alkoholprovet – support och frågor" },
      { property: "og:description", content: "Hör av dig vid frågor om tjänsten, kvitton eller tekniska problem. Svar inom 1–2 arbetsdagar." },
      { property: "og:url", content: "https://alkoholprovet.se/kontakt" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/kontakt" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Alkoholprovet",
          url: "https://alkoholprovet.se",
          logo: "https://alkoholprovet.se/icon-192.png",
          email: "info@alkoholprovet.se",
          contactPoint: [{
            "@type": "ContactPoint",
            contactType: "customer support",
            email: "info@alkoholprovet.se",
            availableLanguage: ["Swedish", "English"],
            areaServed: "SE",
          }],
        }),
      },
    ],
  }),
};
